module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("jNbhU"))).then(() => parcelRequire('7BBrJ'));